import React from 'react';

export default function useDisclosure(initialState = false): [
  boolean,
  {
    toggle: () => void;
    close: () => void;
    open: () => void;
  },
  React.Dispatch<React.SetStateAction<boolean>>,
] {
  const [state, setState] = React.useState(initialState);
  const toggle = React.useCallback(() => setState((prev) => !prev), []);
  const close = React.useCallback(() => {
    setState(false);
  }, []);
  const open = React.useCallback(() => {
    setState(true);
  }, []);
  return [state, { toggle, close, open }, setState];
}
